export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // User Management Page
  'pages.userManagement.title': 'User List',
  'pages.userManagement.id': 'ID',
  'pages.userManagement.email': 'Email',
  'pages.userManagement.username': 'Username',
  'pages.userManagement.nickname': 'Nickname',
  'pages.userManagement.fullName': 'Full Name',
  'pages.userManagement.phone': 'Phone',
  'pages.userManagement.password': 'Password',
  'pages.userManagement.status': 'Status',
  'pages.userManagement.status.active': 'Active',
  'pages.userManagement.status.suspended': 'Suspended',
  'pages.userManagement.status.pending': 'Pending',
  'pages.userManagement.subscriptionTier': 'Subscription Tier',
  'pages.userManagement.tier.free': 'Free',
  'pages.userManagement.tier.pro': 'Pro',
  'pages.userManagement.tier.unlimited': 'Unlimited',
  'pages.userManagement.emailVerified': 'Email Verified',
  'pages.userManagement.verified': 'Verified',
  'pages.userManagement.unverified': 'Unverified',
  'pages.userManagement.quota': 'Quota',
  'pages.userManagement.dailyQuotaLimit': 'Daily Quota Limit',
  'pages.userManagement.oauth': 'OAuth',
  'pages.userManagement.createdAt': 'Created At',
  'pages.userManagement.actions': 'Actions',
  'pages.userManagement.detail': 'Detail',
  'pages.userManagement.edit': 'Edit',
  'pages.userManagement.more': 'More',
  'pages.userManagement.refresh': 'Refresh',
  'pages.userManagement.newUser': 'New User',
  'pages.userManagement.createUser': 'Create User',
  'pages.userManagement.editUser': 'Edit User',
  'pages.userManagement.userDetail': 'User Detail',
  'pages.userManagement.basicInfo': 'Basic Info',
  'pages.userManagement.subscriptionSettings': 'Subscription Settings',
  'pages.userManagement.subscriptionInfo': 'Subscription Info',
  'pages.userManagement.subscriptionExpiresAt': 'Subscription Expires At',
  'pages.userManagement.autoRenew': 'Auto Renew',
  'pages.userManagement.otherSettings': 'Other Settings',
  'pages.userManagement.quotaInfo': 'Quota Info',
  'pages.userManagement.preferences': 'Preferences',
  'pages.userManagement.loginInfo': 'Login Info',
  'pages.userManagement.oauthConnections': 'OAuth Connections',
  'pages.userManagement.language': 'Language',
  'pages.userManagement.timezone': 'Timezone',
  'pages.userManagement.emailNotifications': 'Email Notifications',
  'pages.userManagement.marketingEmails': 'Marketing Emails',
  'pages.userManagement.keyword': 'Keyword',
  'pages.userManagement.keywordPlaceholder': 'Email/Username/Nickname',
  'pages.userManagement.selected': 'Selected',
  'pages.userManagement.item': 'item(s)',
  'pages.userManagement.batchDelete': 'Batch Delete',
  'pages.userManagement.createSuccess': 'Created successfully',
  'pages.userManagement.updateSuccess': 'Updated successfully',
  'pages.userManagement.deleteSuccess': 'Deleted successfully',
  'pages.userManagement.batchDeleteSuccess': 'Batch deleted successfully',
  'pages.userManagement.emailRequired': 'Please enter email',
  'pages.userManagement.emailInvalid': 'Please enter a valid email address',
};
